import { ProjectFromAPI } from '../types';
import { transformProjectResponse } from './api-transforms';
import apiRequest from './apiRequest';

export type TimelineItemPayload = {
  jobID: string;
  title: string;
  trimStart?: number | null;
  trimEnd?: number | null;
  variationNumber?: number;
};

type ProjectTimelinePutPayload = {
  objectID: string;
  stitchFromIndex: number; // index of the first item to be re-stitched
  timeline: TimelineItemPayload[];
  wsConnectionID: string;
  wsHttpEndpoint: string;
};

export default async function putProjectTimeline(
  projectID: string,
  props: ProjectTimelinePutPayload,
) {
  const { data, error } = await apiRequest<{
    project: ProjectFromAPI;
  }>('mogen-orchestration', `/v2/projects/${projectID}/timeline`, {
    method: 'PUT',
    body: JSON.stringify(props),
  });

  return {
    data: data ? transformProjectResponse(data.project) : undefined,
    error,
  };
}
